import { UpgradeIds } from '../enums'
import type { UpgradeFactoryInput } from '../../../../types/UpgradeFactoryInput'
import { DepartmentIds } from '../../departments'
import TwoExponentRiseFactory from './factory'
import departments from '../../departments'

const creatives: UpgradeFactoryInput[] = [
	{
		name: 'Random Keyboard Smashing',
		description:
			"Train bots to type like they're wearing boxing gloves. More authentic!"
	},
	{
		name: 'Emoji Overload',
		description:
			'Replace all words with emojis. Nobody knows what the posts mean anymore.'
	},
	{
		name: 'AI Gone Wrong',
		description:
			'Upgrade bots with AI that exclusively posts about conspiracy theories involving cats.'
	},
	{
		name: 'Quantum Social Network',
		description:
			'Posts exist in a superposition of being both viral and deleted.'
	},
	{
		name: 'Time-Traveling Tweets',
		description:
			"Schedule posts to appear before they're written. Temporal paradoxes included."
	},
	{
		name: 'Multiverse Engagement',
		description:
			'Generate engagement from infinite parallel social media platforms.'
	},
	{
		name: 'Void Posting',
		description: 'Post directly into the void. Zero engagement, infinite reach.'
	}
]

const array = TwoExponentRiseFactory(
	creatives,
	DepartmentIds['Social Media Bot Farm'],
	departments[DepartmentIds['Social Media Bot Farm']].basePrice * 3,
	UpgradeIds.SmbExponent1
)

export default array
